module.exports = __webpack_public_path__ + "static/img/about.d6d89796.png";